import { render, staticRenderFns } from "./top-lang.vue?vue&type=template&id=09b7b110&scoped=true"
import script from "./top-lang.vue?vue&type=script&lang=js"
export * from "./top-lang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b7b110",
  null
  
)

export default component.exports